import React, { useRef } from 'react';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { TextField } from '@milanote/roma';
import CustomColorInput from '../../colorTools/CustomColorInput';
import { useDispatch } from 'react-redux';
import { updateTag } from '../../../../../../../common/tags/tagActions';

type Props = {
    tag: Tag;
};

const TagEditColorButton: React.FC<Props> = ({ tag }) => {
    const dispatch = useDispatch();
    const colorInputRef = useRef<any>(null);

    const handleColorChange = (color: string) => {
        dispatch(updateTag(tag.id, { color }));
    };

    return (
        <div className="TagEditorColorButton flex justify-between items-center">
            <TextField aria-label="Edit color" size="sm">
                Edit color
            </TextField>
            <CustomColorInput ref={colorInputRef} initialColor={tag.color} setColor={handleColorChange} />
        </div>
    );
};

export default TagEditColorButton;
